<template>
  <div class="h-full min-h-screen bg-gray-100 bg-hexagon">
    <div class="flex flex-wrap items-center justify-between px-6 py-6 md:px-10">
      <div class="flex items-center justify-between w-full sm:w-auto">
        <router-link to="/">
          <app-logo width="64px" />
        </router-link>

        <div class="mx-1 sm:mx-6 md:mx-16">
          <a href="https://about.iffent.ee" class="px-6 font-semibold hover:text-blue-500">
            Meist
          </a>
          <router-link to="/privacy-policy" class="px-6 font-semibold hover:text-blue-500">
            Privaatsuspoliitika
          </router-link>
          <router-link to="/terms-of-use" class="px-6 font-semibold hover:text-blue-500">
            Kasutustingimused
          </router-link>
          <a href="https://www.about.iffent.ee/kkk" class="px-6 font-semibold hover:text-blue-500">
            Küsimused & Vastused
          </a>

        </div>
      </div>

      <div v-if="!user.name" class="flex justify-end w-full mt-4 sm:w-auto sm:mt-0">
        <router-link to="/login" class="m-1 bg-blue-100 btn">Sisene</router-link>
        <router-link to="/register" class="m-1 text-white bg-blue-500 btn">Registreeru</router-link>
      </div>
      <div v-else class="flex justify-end w-full mt-4 sm:w-auto sm:mt-0">
        <router-link to="/projects" class="m-1 bg-blue-100 btn hover:text-blue-500"
            >Minu projektid
        </router-link>
      </div>
    </div>

    <div class="container px-6">
      <transition appear name="fade" mode="out-in">
        <div key="homeSlot">
          <slot />
        </div>
      </transition>
    </div>

    <cookie-accept/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CookieAccept from "@/components/CookieAccept";

export default {
    computed: {
        ...mapGetters({
            user: 'global/user',
            isAdmin: 'global/isAdmin',
        }),
    },
    components: {
      CookieAccept
    }
}
</script>
